import { useAppSelector } from 'src/store/store';
import { isT2Admin } from 'src/utils/jmrUtils';

const useIsT2Experience = () => {
  const { featureFlags, ldap } = useAppSelector((state) => state.user);
  const { backgroundFormData, t2AdminToggle } = useAppSelector((state) => state.newJmrPage);

  const canUseToggle = isT2Admin(ldap) && t2AdminToggle !== null;
  const isJobLevelT2Plus = +(backgroundFormData.jobLevel || 0) > 1;

  return featureFlags.T2_PLUS_EXPERIENCE && (canUseToggle ? t2AdminToggle : isJobLevelT2Plus);
};

export default useIsT2Experience;
